// @ts-check
import { gql } from '@apollo/client';
// import { getPage } from '@cloudinary/url-gen/actions/extract';
// import { pad } from '@cloudinary/url-gen/actions/resize';
import { Page } from '@react-pdf/renderer';
import React from 'react';
import { ThemeProvider } from '../../../pdf-design-system/useTheme';
import * as stands from '../helpers/stands';
import VieVinumStandDisplay from './VieVinumStandDisplay';
import theme from './vievinumStandDisplayTheme';

/**
 *
 * @param {{
 * data: import('./@types/VieVinumStandDisplays').VieVinumStandDisplaysFragment;
 * locale: import('@bottlebooks/graphql-server/src').ContentLocale
 * bleed?: number;
 * }} props
 * @returns
 */
export default function VieVinumStandDisplays({
  data,
  locale,
  bleed = 5,
  ...rest
}) {
  const tables = afterQuery(data, rest);

  return (
    <ThemeProvider theme={theme}>
      {tables?.slice(0).map((table) => (
        <Page
          key={table.key}
          size={[`${400 + 2 * bleed}mm`, `${500 + 2 * bleed}mm`]}
          style={{
            paddingHorizontal: `${20 + bleed}mm`,
            paddingVertical: `${20 + bleed}mm`,
          }}
        >
          <Stencil bleed={bleed} />
          <VieVinumStandDisplay data={table} bleed={bleed} />
        </Page>
      ))}
    </ThemeProvider>
  );
}

function Stencil({ bleed }) {
  return null;
  // const stencil = cld
  //   .image('vievinum/Vievinum_Standbeschriftung_2022_400_x_500_mm_02')
  //   .extract(getPage().byNumber(1))
  //   .format('png')
  //   .resize(
  //     pad()
  //       .width(Math.round(400) * mm)
  //       .height(Math.round(500) * mm)
  //   );
  // <Image
  //   fixed
  //   src={stencil.toURL()}
  //   style={{
  //     position: 'absolute',
  //     top: `${bleed}mm`,
  //     left: `${bleed}mm`,
  //     bottom: `${bleed}mm`,
  //     right: `${bleed}mm`,
  //     opacity: 0.3,
  //   }}
  // />
}

VieVinumStandDisplays.fragment = gql/* GraphQL */ `
  fragment VieVinumStandDisplays on CatalogConfiguration {
    catalogConfigurationId
    sections {
      __typename
      ... on RegistrationCatalogSection {
        __typename
        registration {
          registrationId
          ...VieVinumStandDisplay
        }
      }
    }
  }
  ${VieVinumStandDisplay.fragment}
`;

/**
 * @param {import('./@types/VieVinumStandDisplays').VieVinumStandDisplaysFragment} data
 * @param {any} rest
 */
function afterQuery(data, rest) {
  /** @type {Extract<import('./@types/VieVinumStandDisplays').VieVinumStandDisplaysFragment["sections"][number], { __typename: 'RegistrationCatalogSection' }>[]} */ // @ts-ignore
  const sections = data?.sections.filter((section) => {
    if (section.__typename !== 'RegistrationCatalogSection') return false;
    if (rest.companyId) {
      return section.registration.companyId === rest.companyId;
    }
    return true;
  });
  return sections.flatMap(({ registration }) =>
    stands.getNumbers(registration?.stand?.name).map((tableNumber) => ({
      ...registration,
      key: `${registration.registrationId}-${tableNumber}`,
      tableNumber,
    }))
  );
}

/** @typedef {ReturnType<afterQuery>[number]} Table */
